/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  if (!document.body.classList.contains('template-index')) return;
  if (!document.body.classList.contains('features--scroll-snap')) return;

  function updateScrollSnapOffset() {
    // Use the sticky header section height only (announcement scrolls away)
    var headerSection = document.getElementById('shopify-section-header');
    var offset = headerSection ? headerSection.offsetHeight : 0;

    document.documentElement.style.setProperty('--scroll-snap-offset', offset + 'px');
  }

  function markEmptySections() {
    var sections = document.querySelectorAll('#main > .shopify-section');
    sections.forEach(function(section) {
      // Temporarily remove min-height to check natural height
      var prev = section.style.minHeight;
      section.style.minHeight = '0';
      var natural = section.scrollHeight;
      section.style.minHeight = prev;

      if (natural < 10) {
        section.setAttribute('data-scroll-snap-skip', '');
      }
    });
  }

  updateScrollSnapOffset();
  markEmptySections();

  window.addEventListener('resize', updateScrollSnapOffset);
  window.addEventListener('load', function() {
    updateScrollSnapOffset();
    markEmptySections();
  });
})();